// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import PlaceNewEditForm from '../place-new-edit-form';
//


// ----------------------------------------------------------------------

export default function CreatePlaceView() {
    const settings = useSettingsContext();

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="Create a new place"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Place',
                        href: paths.dashboard.place.root,
                    },
                    { name: 'Add Place' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />

            <PlaceNewEditForm currentProduct={null} isView={false} />
        </Container>
    );
}
